export class SummaryAdapter {
  static toOutputDTO(res: any): any {
    return {
      id_code_num: res.user_count,
      record_num: res.time_count,
      node_num: res.column_num,
      data_range: {
        start: res.start_period,
        end: res.end_period,
      },
      uploaded_at: res.uploaded_at,
      used_capacity: res.used_capacity
    };
  }
}
